import type { Branded } from '@/utils/typing/branded.type';
import { hsluvToHex } from 'hsluv';

/**
 * A string following the RGBA hex pattern (with optional transparency)
 * Represented with one byte for each color and one optional byte for the alpha channel
 *
 * Examples:
 * - #FF00FF (without alpha)
 * - #FF00FF2A (with alpha)
 */
export type RgbaColorHex = Branded<string, 'RgbaColorHex'>;

/**
 * A string following the RGB hex pattern (without transparency)
 * Represented with one byte for each color
 *
 * Example:
 * - #FF00FF
 */
export type RgbColorHex = Branded<string, 'RgbColorHex'>;

export function stringToRgbColor(stringHex: string): RgbColorHex {
    if (!/^#[0-9a-f]{6}/i.exec(stringHex)) {
        throw new Error(`Color does not match the rgb pattern:: ${stringHex}`);
    }
    return stringHex as RgbColorHex;
}

export function hsluvToRgbColorHex(hue: number, saturation: number, luminosity: number): RgbColorHex {
    return stringToRgbColor(hsluvToHex([hue, saturation, luminosity]));
}

export function addAlphaToHexColor(colorHexWithoutAlpha: RgbColorHex, opacity: number): RgbaColorHex {
    const opacityByte = Math.floor(opacity * 255);
    return `${colorHexWithoutAlpha}${opacityByte !== 255 ? opacityByte.toString(16) : ''}` as RgbaColorHex;
}
